import { useCallback, useEffect, useState } from "react";

// import useTimer from "./useTimer";

import dayjs from "dayjs";
import { useTimeControlStore, useTimeStore } from "@graphic/stores";

type Mark = {
  value: number;
  label: string;
};

export const useSlider = () => {
  const { defaultTime } = useTimeControlStore(state => ({
    defaultTime: state.defaultTime
  }));
  const { time, setTime } = useTimeStore();

  const [minTime, setMinTime] = useState<Dayjs>();
  const [marks, setMarks] = useState<Mark[]>([]);

  const sliderValue = time.valueOf();

  const timelength = 7;

  // const [sliderValue, setSliderValue] = useState(0);

  useEffect(() => {
    if (!defaultTime) return;
    // get three hours before from current time and set minute and second to 0
    const newMinTime = dayjs(defaultTime)
      .subtract(3, "hour")
      .minute(0)
      .second(0)
      .millisecond(0);

    setMinTime(newMinTime);

    // set marks
    let marks: Mark[] = [];

    for (let i = 0; i < timelength; i++) {
      const value = dayjs(newMinTime).add(i, "hour");
      // let label = `${value.getUTCHours()}:00`;
      let label = `${value.hour()}:00`;

      const mark = {
        value: value.valueOf(),
        label
      };
      marks = [...marks, mark];
    }
    setMarks(marks);
  }, [defaultTime]);

  // useEffect(() => {
  //   setSliderValue(time.valueOf());
  // }, [time]);

  const handleSliderChange = (value: number) => {
    if (typeof value === "object") return;
    // setSliderValue(value);
    const newTime = dayjs(value);
    setTime(newTime);
  };

  const valueLabelFormat = useCallback((value: number) => {
    return dayjs(value).format("HH:mm:ss");
  }, []);

  return {
    sliderValue,
    minTime,
    marks,
    handleSliderChange,
    valueLabelFormat,
    timelength
  };
};

export default useSlider;
